import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CoupanServices from '../../services/CoupanServices';

function AddCoupan() {
    const navigate = useNavigate();

    const [formValues, setFormValues] = useState({
        name: '',
        description: '',
        upto: '',
        numberOfCoupons: '',
        endDate: '',
        price: '',
        discountType: '',
        maxDiscountAmount: '',
        termsAndConditions: '',
        totalnumberOfusagesCoupons: '',
        totalnumberOfusagesperuserCoupons: '',

    });

    // Handle form input changes
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };
    const validateForm = () => {
        const { endDate } = formValues;
        const currentDate = new Date();
        const selectedEndDate = new Date(endDate);
      
        // Ensure the end date is not earlier than the current date
        if (selectedEndDate < currentDate.setHours(0, 0, 0, 0)) {
            alert('End Date cannot be earlier than today.');
            return false;
          }
      
        return true;
      };
    // Handle form submission
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!validateForm()) return;
        try {
            const formData = new FormData();
            for (const key in formValues) {
                formData.append(key, formValues[key]);
            }

            await CoupanServices.createCoupan(formValues);
            alert('Coupan created successfully');
            navigate('/coupon-list');
        } catch (error) {
            console.error('Failed to create Coupan', error);
            alert(error.response?.data?.message || 'Failed to create Coupan');
        
        }
    };

    return (
        <>
            <div className="right_col" role="main">
                <div className="title-box">
                    <h2>Generate Coupon Code</h2>
                    <div className="container-box-top-header-right">
                        <Link className="list-banner-btn" to="/coupon-list">Coupan Code List</Link>
                    </div>
                </div>
                <div className="container-box px-5">
                    <div className="container-box-inner table-reponsive-tabe">
                        <div className="page-details">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                        <div className="input-field">
                                            <label>Name Of Coupon<span className="red">*</span></label>
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                value={formValues.name}
                                                onChange={handleInputChange}
                                                placeholder="Enter name"
                                                
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="input-field">
                                            <label>Description<span className="red">*</span></label>
                                            <textarea
                                                className="form-control video-desc"
                                                name="description"
                                                value={formValues.description}
                                                onChange={handleInputChange}
                                                placeholder="Enter description"
                                                
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Up to Discount (%)</label>
                                            <input
                                                type="number"
                                                name="upto"
                                                className="form-control"
                                                value={formValues.upto}
                                                onChange={handleInputChange}
                                                placeholder="50"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>MAX Discount Amount</label>
                                            <input
                                                type="number"
                                                name="maxDiscountAmount"
                                                className="form-control"
                                                value={formValues.maxDiscountAmount}
                                                onChange={handleInputChange}
                                                placeholder="500"
                                            />
                                        </div>
                                    </div>


                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Total Number of usages</label>
                                            <input
                                                type="number"
                                                name="totalnumberOfusagesCoupons"
                                                className="form-control"
                                                value={formValues.totalnumberOfusagesCoupons}
                                                onChange={handleInputChange}
                                                placeholder="10"
                                            />
                                        </div>
                                    </div>


                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Total Number of usage per user</label>
                                            <input
                                                type="number"
                                                name="totalnumberOfusagesperuserCoupons"
                                                className="form-control"
                                                value={formValues.totalnumberOfusagesperuserCoupons}
                                                onChange={handleInputChange}
                                                placeholder="2"
                                            />
                                        </div>
                                    </div>


                                    <div className="col-lg-3 col-sm-6">
                                        <div className="input-field">
                                            <label>Number Of Coupons<span className="red">*</span></label>
                                            <input
                                                type="text"
                                                name="numberOfCoupons"
                                                className="form-control"
                                                value={formValues.numberOfCoupons}
                                                onChange={handleInputChange}
                                                placeholder="50"            
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-3">
                                        <div className="input-field">
                                            <label>Amount<span className="red">*</span></label>
                                            <input
                                                type="number"
                                                name="price"
                                                className="form-control"
                                                value={formValues.price}
                                                onChange={handleInputChange}
                                                placeholder="₹ 200"     
                                                min="0"
                                                step="0"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="input-field">
                                            <label>Expire Date<span className="red">*</span></label>
                                            <input
                                                type="date"
                                                name="endDate"
                                                className="form-control"
                                                value={formValues.endDate}
                                                onChange={handleInputChange}  
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3 d-flex align-items-center">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="discountType"
                                                value="Percentage"
                                                checked={formValues.discountType === 'Percentage'}
                                                onChange={handleInputChange}
                                            />
                                            <label className="form-check-label add-vechile-check-btn">
                                                Percentage
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-sm-12">
                                        <div className="input-field">
                                            <label> Terms And Conditions</label>
                                            <textarea
                                                className="form-control video-desc"
                                                name="termsAndConditions"
                                                value={formValues.termsAndConditions}
                                                onChange={handleInputChange}
                                                placeholder="Enter Terms And Conditions"
                                                
                                            />
                                        </div>
                                    </div>

                                    {/* <div className="col-md-2 d-flex align-items-center">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="discountType"
                                                value="Rupees"
                                                checked={formValues.discountType === 'Rupees'}
                                                onChange={handleInputChange}
                                            />
                                            <label className="form-check-label add-vechile-check-btn">
                                                Rupees
                                            </label>
                                        </div>
                                    </div> */}
                                </div>
                                <button className="submit-green-btn">SUBMIT</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddCoupan;
